export default __webpack_public_path__ + "static/servicesMobileDecorator-dc15071e709d11c8241603c6a20e7872.png";